import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'
// import { notification } from 'antd'
import constants from '../constants'

export default function init() {
  console.log('bots init')
}

export async function list(app, apiHost, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/bots?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/bots`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      // let errDescription = error.response.data.error.message;
      //         if(error.response.data.error.details !== undefined && error.response.data.error.details.webhookURL !== undefined)
      //         {
      //           const {webhookURL : webhookURLErr} = error.response.data.error.details;
      //           errDescription = webhookURLErr;
      //         }
      //         else if(error.response.data.error.details !== undefined && error.response.data.error.details.uid !== undefined)
      //         {
      //           const {uid : uidErr} = error.response.data.error.details;
      //           errDescription = uidErr;
      //         }
      //         notification.warning({
      //           message: 'Error creating bot',
      //           description: errDescription,
      //         })
      //         return false;
      return error.response.data
    })
}

export async function get(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/bots/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/bots/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/bots/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
